import type { SetupTourDefinition } from '../core/types';

export const VEHICLES_SETUP_TOUR_TARGETS = {
  sidebarVehiclesLink: 'vehicles-sidebar-link',
  addVehicleButton: 'vehicles-list-add-button',
  createForm: 'vehicles-create-form',
  basicInfoSection: 'vehicles-basic-info-section',
  damagePhotosSection: 'vehicles-damage-photos-section',
  usageSection: 'vehicles-usage-section',
  insuranceRoadAssistanceSection: 'vehicles-insurance-road-assistance-section',
  serviceInspectionsSection: 'vehicles-service-inspections-section',
  stationSection: 'vehicles-station-section',
  submitButton: 'vehicles-submit-button',
} as const;

export const vehiclesSetupTour: SetupTourDefinition = {
  id: 'vehicles_setup',
  label: 'Vehicles Setup',
  onboardingKey: 'vehicles_setup',
  sidebarTargetsByRoute: {
    '/vehicles': VEHICLES_SETUP_TOUR_TARGETS.sidebarVehiclesLink,
  },
  steps: [
    {
      id: 'sidebar-vehicles',
      route: '/vehicles',
      target: VEHICLES_SETUP_TOUR_TARGETS.sidebarVehiclesLink,
      content: 'Click Vehicles in the sidebar to set up your fleet vehicles.',
      advanceOnTargetClick: true,
      expandSidebarKeys: ['/fleet'],
    },
    {
      id: 'add-vehicle',
      route: '/vehicles',
      target: VEHICLES_SETUP_TOUR_TARGETS.addVehicleButton,
      content: 'Click Add New Vehicle to create your first vehicle.',
      advanceOnTargetClick: true,
    },
    {
      id: 'basic-information',
      route: '/vehicles/create',
      target: VEHICLES_SETUP_TOUR_TARGETS.basicInfoSection,
      content: 'Enter the Plate Number and select the Vehicle Type, Brand, Model, and Year.',
      showRequiredFieldsOnEnter: true,
      next: {
        guardTarget: VEHICLES_SETUP_TOUR_TARGETS.basicInfoSection,
      },
    },
    {
      id: 'damage-photos',
      route: '/vehicles/create',
      target: VEHICLES_SETUP_TOUR_TARGETS.damagePhotosSection,
      content: 'Add damage photos if available.',
    },
    {
      id: 'usage',
      route: '/vehicles/create',
      target: VEHICLES_SETUP_TOUR_TARGETS.usageSection,
      content: 'Enter the current distance and its last-updated date (optional).',
    },
    {
      id: 'insurance-road-assistance',
      route: '/vehicles/create',
      target: VEHICLES_SETUP_TOUR_TARGETS.insuranceRoadAssistanceSection,
      content: 'Add insurance and road-assistance details (optional).',
    },
    {
      id: 'service-inspections',
      route: '/vehicles/create',
      target: VEHICLES_SETUP_TOUR_TARGETS.serviceInspectionsSection,
      content: 'Add service and inspection dates (optional).',
    },
    {
      id: 'station',
      route: '/vehicles/create',
      target: VEHICLES_SETUP_TOUR_TARGETS.stationSection,
      content: 'Select a station for the vehicle.',
      showRequiredFieldsOnEnter: true,
      next: {
        guardTarget: VEHICLES_SETUP_TOUR_TARGETS.stationSection,
      },
    },
    {
      id: 'create-vehicle',
      route: '/vehicles/create',
      target: VEHICLES_SETUP_TOUR_TARGETS.submitButton,
      content: 'Click Create to save the vehicle and add it to the fleet.',
      directNextTargets: [VEHICLES_SETUP_TOUR_TARGETS.submitButton],
      next: {
        label: 'Create',
        action: { type: 'click' },
        waitForTargetRemoval: VEHICLES_SETUP_TOUR_TARGETS.submitButton,
        completesTour: true,
      },
    },
  ],
};
